export default "__VITE_ASSET__DfTK$V4K__";